import React, { useState, useEffect } from "react";
import { dashboard } from "../../services/api";
import "./Dashboard.css";

function Dashboard() {
  const [stats, setStats] = useState(null);
  const [shop, setShop] = useState(null);
  const [mode, setMode] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const data = await dashboard.getStats();
        setStats(data.stats);
        setShop(data.shop);
        setMode(data.mode);
      } catch (err) {
        console.error("Failed to load stats:", err);
      }
      setLoading(false);
    };
    fetchStats();
    const interval = setInterval(fetchStats, 30000);
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return <div className="dashboard-loading">Loading dashboard...</div>;
  }

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1>Dashboard</h1>
        <span className={`mode-badge mode-${mode}`}>
          {mode === "dev" ? "DEV MODE" : "PRODUCTION"}
        </span>
      </div>

      {shop && (
        <div className="shop-info">
          <div className="shop-info-item">Shop: <strong>{shop.shop_domain}</strong></div>
          <div className="shop-info-item">Scopes: <strong>{shop.scope}</strong></div>
          <div className="shop-info-item">Installed: <strong>{shop.installed_at}</strong></div>
        </div>
      )}

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label">Total Orders</div>
          <div className="stat-value stat-total">{stats?.total || 0}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Pending</div>
          <div className="stat-value stat-pending">{stats?.pending || 0}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Confirmed</div>
          <div className="stat-value stat-confirmed">{stats?.confirmed || 0}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Cancelled</div>
          <div className="stat-value stat-cancelled">{stats?.cancelled || 0}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Failed</div>
          <div className="stat-value stat-failed">{stats?.failed || 0}</div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
